import React from 'react';
import { Sticky } from 'react-sticky';
import cn from 'classnames';
import styles from '../../styles.module.scss';
import CTAstyles from './cta.module.scss';
import AddToShoppingCartButtonComponent from '../../components/AddToShoppingCartButton';
import { VenueProfileContext } from '../../context';
import { Venues } from '@weddingspot/ws-api-client';
import { TagIcon } from '@cvent/carina/components/Icon';
import Button from '@cvent/carina/components/Button';
import CtaMobile from './CTAMobile';
import { toUSD } from '@weddingspot/ws-core-components';

const Cta = () => {
    const context = React.useContext(VenueProfileContext);

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, []) as Venues.VenueDetails;

    const priceVenueClickHandler = () => {
        window.open(`/pricing/${wsVenueProfile.id}/estimate/`);
    };
    const isShortPrice = Math.floor(wsVenueProfile.cost_min / 1000) > 0;

    return (
        <>
            <Sticky topOffset={-101} bottomOffset={500} disableCompensation={true}>
                {({ style, distanceFromTop, isSticky }) => (
                    <div style={{ ...style }}>
                        <div
                            className={cn(CTAstyles.CTA, CTAstyles.CTAAddToList, {
                                [CTAstyles.CTAAddToListNotSticky]: !isSticky,
                            })}
                        >
                            <div className={CTAstyles.CTAContainer}>
                                <h2>Send this venue a request</h2>
                                <p className={CTAstyles.description}>
                                    Add it to your list to send a request to mulitple venues at the same time.{' '}
                                </p>
                                <div className={CTAstyles.buttons}>
                                    <AddToShoppingCartButtonComponent labelText='Add to list' nonPrimary={false} />
                                </div>
                            </div>
                        </div>

                        { wsVenueProfile.is_priced && (
                        <div
                            className={cn(CTAstyles.CTA, CTAstyles.CTAPrice, {
                                [CTAstyles.CTAPriceNotSticky]: !isSticky,
                            })}
                        >
                            <div className={cn(CTAstyles.CTAContainer,{
                                [CTAstyles.CTAContainer_noButtons]: context.personalizedData?.estimate_completed || !wsVenueProfile.is_priced,
                            })}>
                                {wsVenueProfile.discount && (
                                    <div className={CTAstyles.top}>
                                        <TagIcon />
                                        <p>{wsVenueProfile.discount.description}</p>
                                    </div>
                                )}
                                <h2>
                                    {context.personalizedData?.spot_estimate && (
                                        <>
                                            Your Spot Estimate:
                                            <a onClick={priceVenueClickHandler}>{toUSD(context.personalizedData.spot_estimate)}</a>
                                        </>
                                    )}
                                    {!context.personalizedData?.spot_estimate && wsVenueProfile.is_priced && !!wsVenueProfile.budget_range && (
                                        <>
                                            Starting at <b>{toUSD(wsVenueProfile.budget_range.min)} </b>
                                            for <b>{wsVenueProfile.budget_range.capacity}</b> Guests
                                        </>
                                    )}
                                </h2>
                                <p className={cn(CTAstyles.description,{
                                    [CTAstyles.description_noButtons]: context.personalizedData?.estimate_completed || !wsVenueProfile.is_priced,
                                })}>Use our Spot Estimate tool to quickly calculate an estimated price.</p>
                                <div className={CTAstyles.buttons}>
                                    {!context.personalizedData?.estimate_completed && wsVenueProfile.is_priced && (
                                        <Button text='Price venue' appearance={'lined'} onClick={priceVenueClickHandler} />
                                    )}
                                </div>
                            </div>
                        </div>)}
                    </div>
                )}
            </Sticky>
            <div className={styles.CTATablet}>
                <div className={styles.CTAcost}>
                    {wsVenueProfile.discount && (
                        <div className={styles.CTApin}>
                            <TagIcon />
                            Deal <span>Available</span>
                        </div>
                    )}
                    <div className={styles.CTAStarting}>
                        {context.personalizedData?.spot_estimate && (
                            <>
                                Your Spot Estimate:
                                <a onClick={priceVenueClickHandler}>{toUSD(context.personalizedData.spot_estimate)}</a>
                            </>
                        )}
                        {!context.personalizedData?.spot_estimate && wsVenueProfile.is_priced && !!wsVenueProfile.budget_range && (
                            <>
                                Starting at <b>${Math.floor(wsVenueProfile.budget_range.min / 1000)}k </b>
                                for <b>{wsVenueProfile.budget_range.capacity}</b> Guests
                            </>
                        )}
                    </div>
                </div>

                <div className={styles.CTAMobButtons}>
                    {!context.personalizedData?.estimate_completed && wsVenueProfile.is_priced && (
                        <Button text='Price venue' appearance={'filled'} isPill={true} onClick={priceVenueClickHandler} />
                    )}
                    <AddToShoppingCartButtonComponent />
                </div>
            </div>
            <CtaMobile priceVenueClickHandler={priceVenueClickHandler} toUSD={toUSD} />
        </>
    );
};

export default Cta;
